<!--
 * @Author: LiuMeiYu
 * @Date: 2023-02-02 09:50:57
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-03-15 16:50:11
 * @FilePath: \nivara\src\views\wallet\components\withdrawaPasswordView.vue
 * @Description: *
 * *
 * Copyright (c) 2023 by yihua, All Rights Reserved.
-->
<template>
  <div class="withdraw-password-container" v-loading="userInfoLoading">
    <!-- 设置交易密码 -->
    <el-form
      class="withdraw-password-form"
      :model="setWithdrawPasswordData"
      label-position="top"
      v-if="userInfoData.t_password_null"
    >
      <el-form-item label="Enter withdrawal password">
        <el-input
          v-model="setWithdrawPasswordData.password"
          type="password"
          show-password
          ref="passwordRef"
          maxlength="20"
          placeholder="Please Enter withdrawal password"
        />
      </el-form-item>
      <el-form-item label="Enter your withdrawal password again">
        <el-input
          v-model="setWithdrawPasswordData.passwordAgain"
          type="password"
          show-password
          ref="passwordAgainRef"
          maxlength="20"
          placeholder="Please Enter your withdrawal password again"
        />
      </el-form-item>
      <el-form-item>
        <div class="passwprd-tips">
          The password must contain at least 6 numbers.
        </div>
      </el-form-item>
      <el-form-item>
        <el-button @click="setWithdrawPassword">Submit</el-button>
      </el-form-item>
    </el-form>
    <!-- 修改交易密码 -->
    <el-form
      class="withdraw-password-form"
      :model="updateWithdrawPasswordData"
      label-position="top"
      v-else
    >
      <el-form-item label="Current withdrawal password">
        <el-input
          v-model="updateWithdrawPasswordData.currentPassword"
          type="password"
          show-password
          ref="currentPasswordRef"
          maxlength="20"
          placeholder="Current password"
        />
      </el-form-item>
      <el-form-item label="Enter your new withdrawal password">
        <el-input
          v-model="updateWithdrawPasswordData.newPassword"
          type="password"
          show-password
          ref="newPasswordRef"
          maxlength="20"
          placeholder="New password"
        />
      </el-form-item>
      <el-form-item>
        <div class="passwprd-tips">
          The password must contain at least 6 numbers.
        </div>
      </el-form-item>
      <el-form-item>
        <el-button @click="updateWithdrawPassword">Submit</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  ref,
  nextTick,
  toRefs,
  onMounted,
} from "@vue/runtime-core";
import {
  setWithdrawPasswordApi,
  updateWithdrawUpTPasswordApi,
  getUserInfoApi,
} from "../../../api/index";
import { ElNotification } from "element-plus";

export default defineComponent({
  name: "Wallet",
  components: {},
  setup() {
    onMounted(() => {
      getUserInfo();
    });
    const walletType = ref(0);
    const passwordRef = ref(0);
    const passwordAgainRef = ref(0);
    const currentPasswordRef = ref(0);
    const newPasswordRef = ref(0);
    const state = reactive({
      setWithdrawPasswordData: {
        password: "",
        passwordAgain: "",
      },
      updateWithdrawPasswordData: {
        currentPassword: "",
        newPassword: "",
      },
      userInfoData: {},
    });
    const setWithdrawPassword = () => {
      if (state.setWithdrawPasswordData.password) {
        if (state.setWithdrawPasswordData.password.length >= 6) {
          if (state.setWithdrawPasswordData.passwordAgain) {
            if (
              state.setWithdrawPasswordData.password ===
              state.setWithdrawPasswordData.passwordAgain
            ) {
              setWithdrawPasswordApi({
                token: localStorage.getItem("token"),
                password: state.setWithdrawPasswordData.password,
              }).then((res) => {
                if (res.data.success) {
                  ElNotification({
                    title: "Tips",
                    message: "Setting Success",
                    type: "success",
                    duration: 2000,
                  });
                  nextTick(() => {
                    state.setWithdrawPasswordData.password = "";
                    state.setWithdrawPasswordData.passwordAgain = "";
                    getUserInfo();
                  });
                } else {
                  ElNotification({
                    title: "Tips",
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            } else {
              ElNotification({
                title: "Tips",
                message: "Inconsistent passwords",
                type: "error",
                duration: 2000,
              });
            }
          } else {
            ElNotification({
              title: "Tips",
              message: "Please Enter your withdrawal password again",
              type: "error",
              duration: 2000,
            });
            passwordAgainRef.value.focus();
          }
        } else {
          ElNotification({
            title: "Tips",
            message: "The password must contain at least 6 numbers.",
            type: "error",
            duration: 2000,
          });
          passwordRef.value.focus();
        }
      } else {
        ElNotification({
          title: "Tips",
          message: "Please Enter withdrawal password",
          type: "error",
          duration: 2000,
        });
        passwordRef.value.focus();
      }
    };
    const updateWithdrawPassword = () => {
      if (state.updateWithdrawPasswordData.currentPassword) {
        if (state.updateWithdrawPasswordData.currentPassword.length >= 6) {
          if (state.updateWithdrawPasswordData.newPassword) {
            if (state.updateWithdrawPasswordData.newPassword.length >= 6) {
              updateWithdrawUpTPasswordApi({
                password: state.updateWithdrawPasswordData.currentPassword,
                new_password: state.updateWithdrawPasswordData.newPassword,
              }).then((res) => {
                if (res.data.success) {
                  ElNotification({
                    title: "Tips",
                    message: "Update Success",
                    type: "success",
                    duration: 2000,
                  });
                  nextTick(() => {
                    state.updateWithdrawPasswordData.currentPassword = "";
                    state.updateWithdrawPasswordData.newPassword = "";
                    getUserInfo();
                  });
                } else {
                  ElNotification({
                    title: "Tips",
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            } else {
              ElNotification({
                title: "Tips",
                message: "The new password must contain at least 6 numbers.",
                type: "error",
                duration: 2000,
              });
            }
          } else {
            ElNotification({
              title: "Tips",
              message: "Please Enter your new withdrawal password",
              type: "error",
              duration: 2000,
            });
            newPasswordRef.value.focus();
          }
        } else {
          ElNotification({
            title: "Tips",
            message: "The password must contain at least 6 numbers.",
            type: "error",
            duration: 2000,
          });
          currentPasswordRef.value.focus();
        }
      } else {
        ElNotification({
          title: "Tips",
          message: "Please Enter current withdrawal password",
          type: "error",
          duration: 2000,
        });
        currentPasswordRef.value.focus();
      }
    };
    const userInfoLoading = ref(false);
    const getUserInfo = () => {
      userInfoLoading.value = true;
      getUserInfoApi({ token: localStorage.getItem("token") }).then((res) => {
        console.log("getUserInfoApi：", res);
        if (res.data.success) {
          state.userInfoData = res.data.data;
          userInfoLoading.value = false;
        } else {
          userInfoLoading.value = false;
          ElNotification({
            title: "Tips",
            message: res.data.msg,
            type: "error",
          });
        }
      });
    };
    return {
      walletType,
      passwordRef,
      passwordAgainRef,
      currentPasswordRef,
      newPasswordRef,
      setWithdrawPassword,
      updateWithdrawPassword,
      userInfoLoading,
      ...toRefs(state),
    };
  },
});
</script>

<style lang="less" scoped>
.withdraw-password-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  .withdraw-password-form {
    :deep(.el-form-item) {
      margin-bottom: 10px;
    }
    :deep(.el-form-item__label) {
      padding: 0;
      color: #000000;
    }
    :deep(.el-input__inner) {
      border-radius: 12px;
    }
    .el-input {
      min-width: 400px;
    }
    .passwprd-tips {
      text-align: left;
    }
    .el-button {
      background-color: #03004d;
      border-radius: 12px;
      color: #ffffff;
    }
  }
}
</style>
